<mat-card>
  <div #exportContent>

    <div class="header">
      <div class="title"> Highest Total Cost Counties</div>
      <button class="header-btn" mat-icon-button data-html2canvas-ignore (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <table mat-table [dataSource]="tableSource">
        <!-- rank column -->
        <ng-container matColumnDef="rank">
          <td mat-cell *matCellDef="let r" class="text-center">{{ r.rank }}</td>
        </ng-container>
        <!-- total cost -->
        <ng-container matColumnDef="totalCost">
          <th mat-header-cell *matHeaderCellDef colspan="2">
            <strong>Highest Total Cost</strong>
            <br/><span class="sub-header">By County</span>
          </th>
          <td mat-cell *matCellDef="let r">
            {{ r.totalEntry.properties.name }}
          </td>
        </ng-container>
        <!-- cost per customer event -->
        <ng-container matColumnDef="costPerCustomerEvent">
          <th mat-header-cell *matHeaderCellDef>
            <strong>Highest Per Customer Cost</strong>
            <br/><span class="sub-header">By County</span>
          </th>
          <td mat-cell *matCellDef="let r">
            {{ r.perCustomerEventEntry.properties.name }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns.slice(1)"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-card-content>
  </div>

</mat-card>
